import { render, staticRenderFns } from "./ShopCreateView.vue?vue&type=template&id=b48bab3c"
import script from "./ShopCreateView.vue?vue&type=script&lang=js"
export * from "./ShopCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports